import { isBlank, isPresent } from 'shared/lib/utils';

export function isForkedAnnotation(annotation) {
  return isPresent(annotation.get('createdFrom'));
}

export function areTitleAndSummaryEmpty(annotation) {
  return isBlank(annotation.get('title')) && isBlank(annotation.get('summary'));
}

export function isUntouchedForkedAnnotation(annotation) {
  return isForkedAnnotation(annotation) && areTitleAndSummaryEmpty(annotation);
}

export function annotationEventTitle(annotation) {
  switch (annotation.getIn(['source', 'type'])) {
    case 'tweet':
      // TODO(i18n).
      return `@${annotation.getIn(['event', 'user', 'screenName'])} tweeted: ${
        annotation.getIn(['event', 'fullText']) ||
        annotation.getIn(['event', 'text'])
      }`;
    case 'website':
      return annotation.getIn(['event', 'title']);
    case 'self':
      return annotation.get('title');
    default:
      console.error(
        `Don't know how to get event title for annotation: ${annotation.toJS()}`
      );
      return '';
  }
}

export function derivedTitle(annotation) {
  let derivedTitle = null;

  if (isForkedAnnotation(annotation) && isBlank(annotation.get('title'))) {
    derivedTitle = annotation.getIn(['createdFrom', 'title']);
  } else if (isPresent(annotation.get('title'))) {
    derivedTitle = annotation.get('title');
  } else if (annotation.has('event')) {
    derivedTitle = annotationEventTitle(annotation);
  }

  return derivedTitle || '';
}

export function annotationEventSummary(annotation) {
  switch (annotation.getIn(['source', 'type'])) {
    case 'tweet':
      return '';
    case 'website':
      return annotation.getIn(['event', 'description']);
    default:
      console.error(
        `Don't know how to get event summary for annotation: ${annotation.toJS()}`
      );
      return '';
  }
}

export function derivedSummary(annotation) {
  if (isForkedAnnotation(annotation) && isBlank(annotation.get('summary'))) {
    return annotation.getIn(['createdFrom', 'summary']);
  } else if (isPresent(annotation.get('summary'))) {
    return annotation.get('summary');
  } else if (annotation.has('event')) {
    return annotationEventSummary(annotation);
  }

  return '';
}
